export const DISCIPLINAS = [
  "Matemática", "Língua Portuguesa", "História", "Geografia",
  "Ciências", "Inglês", "Artes", "Educação Física", "Ensino Religioso", "Outra disciplina"
];

export const SERIES = [
  "Educação Infantil",
  "1º ano", "2º ano", "3º ano", "4º ano", "5º ano",
  "6º ano", "7º ano", "8º ano", "9º ano",
  "1º ano do Ensino Médio", "2º ano do Ensino Médio", "3º ano do Ensino Médio",
];

export const NIVEIS = ["Iniciante", "Regular", "Avançado", "Reforço"];
export const DIFICULDADES = ["Fácil", "Média", "Difícil"];
export const TIPOS_QUESTAO = ["Múltipla escolha", "Verdadeiro ou falso", "Discursiva", "Problemas", "Mista"];

export const ACOES_ADAPTAR = [
  "Tornar mais fácil",
  "Tornar mais difícil",
  "Simplificar a linguagem",
  "Adaptar para outra série",
  "Reduzir quantidade de questões",
  "Aumentar quantidade de questões",
];
